import {GET} from "@/services/gateway";

const getBackupsByDay = () => {
  return GET('dashboard/google/backups')
}

export {
  getBackupsByDay,
}
